import httpApi from "@src/utils/httpApi";
import {
  ICuratorConversation,
  ICuratorConversationStatus,
} from "@src/types/curator";

const ADMIN_CONVERSATIONS_URL =
  "/api/curator-conversations/admin/conversations";

export type AdminConversationsPagination = {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
};

export type AdminConversationsPage = {
  conversations: ICuratorConversation[];
  pagination: AdminConversationsPagination;
};

export type AdminConversationsParams = {
  status?: ICuratorConversationStatus;
  curatorDocumentId?: string;
  clientDocumentId?: string;
  search?: string;
  page?: number;
  pageSize?: number;
};

/** One page of chat history. Messages come back oldest → newest. */
export type AdminConversationHistoryPage = {
  messages: Record<string, unknown>[];
  nextCursor: string | null;
  hasMore: boolean;
};

const EMPTY_PAGINATION: AdminConversationsPagination = {
  page: 1,
  pageSize: 0,
  pageCount: 0,
  total: 0,
};

export const getAdminConversations = async (
  params: AdminConversationsParams = {}
): Promise<AdminConversationsPage> => {
  const response = await httpApi.get<{
    data: ICuratorConversation[];
    meta?: { pagination?: AdminConversationsPagination };
  }>(ADMIN_CONVERSATIONS_URL, { params });

  const conversations = response.data.data || [];
  return {
    conversations,
    pagination: response.data.meta?.pagination ?? {
      ...EMPTY_PAGINATION,
      pageSize: conversations.length,
      total: conversations.length,
    },
  };
};

export const getAdminConversationHistory = async (
  conversationId: string,
  params: { pageSize?: number; before?: string } = {}
): Promise<AdminConversationHistoryPage> => {
  const response = await httpApi.get<{
    data: Record<string, unknown>[];
    meta?: { nextCursor?: string | null; hasMore?: boolean };
  }>(`${ADMIN_CONVERSATIONS_URL}/${conversationId}/history`, { params });

  return {
    messages: response.data.data || [],
    nextCursor: response.data.meta?.nextCursor ?? null,
    hasMore: Boolean(response.data.meta?.hasMore),
  };
};
